import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import your translation files
import translationEN from "../locales/en";
// Add more imports for other languages

i18n.use(initReactI18next).init({
  resources: {
    en: translationEN,
    // Add more languages and translations here
  },
  lng: "en", // Set the default language
  fallbackLng: "en", // Fallback language if translation is missing
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
